import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BreadcrumbResolver } from './breadcrumb-resolver';
import { Breadcrumb } from '@tc-angular/design-system';

@Injectable({ providedIn: 'root' })
export class PaymentsBreadcrumbResolver implements BreadcrumbResolver {
  private readonly baseBreadcrumbs: Breadcrumb[] = [
    {
      label: 'nav.dashboard',
      routerLink: ['/'],
    },
    {
      label: 'nav.payments',
      routerLink: undefined,
    },
  ];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public resolve(params: unknown): Observable<Breadcrumb[]> {
    return of(this.baseBreadcrumbs);
  }
}
